import { createSelector } from '@ngrx/store';
import { selectCurrentBusinessProfile } from './business-profiles.selectors';

export const selectAdditionalTrackingData = createSelector(selectCurrentBusinessProfile, (currentBusinessProfile) => ({
  currentBusinessProfile
}));
